/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PickaxeSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M9.894 3.529c-.365-.23-.23-.777.22-.817 1.758-.154 4.34.04 6.51 1.106a1 1 0 0 1 1.365.046l2.122 2.121a1 1 0 0 1 .068 1.339c1.08 2.087 1.29 4.505 1.135 6.477-.037.465-.625.625-.863.247-1.178-1.865-2.044-3.208-2.855-4.285a1 1 0 0 1-1.02-.242l-.354-.354L4.2 21.187a.5.5 0 0 1-.707 0l-.707-.706a.5.5 0 0 1 0-.707l12.02-12.021-.353-.354a1 1 0 0 1-.247-1.006c-1.085-.81-2.438-1.681-4.313-2.864Z" /></svg>);
const PickaxeSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PickaxeSolidBase} {...rest} ref={ref} />);
export default PickaxeSolid;